import { Fragment } from 'preact'

import type { CookieConsentTranslator } from '#src/assets/lib/i18n.ts'
import { Heading } from '#src/assets/ui/shared/components/Heading.tsx'
import { Paragraph } from '#src/assets/ui/shared/components/Paragraph.tsx'

export function PolicySectionConsent({ t }: { t: CookieConsentTranslator }) {
  return (
    <Fragment>
      <Heading level={3}>{t('policyConsentTitle')}</Heading>
      <Paragraph>{t('policyConsentBody')}</Paragraph>
    </Fragment>
  )
}
